import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteCallGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  relatedData: Types.CallGroupRetargets;
}>;


export type DeleteCallGroupMutation = { __typename?: 'Mutation', deleteCallGroup?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const DeleteCallGroupDocument = gql`
    mutation DeleteCallGroup($id: Int!, $relatedData: CallGroupRetargets!) {
  deleteCallGroup(id: $id, relatedData: $relatedData) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type DeleteCallGroupMutationFn = Apollo.MutationFunction<DeleteCallGroupMutation, DeleteCallGroupMutationVariables>;

/**
 * __useDeleteCallGroupMutation__
 *
 * To run a mutation, you first call `useDeleteCallGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCallGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCallGroupMutation, { data, loading, error }] = useDeleteCallGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      relatedData: // value for 'relatedData'
 *   },
 * });
 */
export function useDeleteCallGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCallGroupMutation, DeleteCallGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCallGroupMutation, DeleteCallGroupMutationVariables>(DeleteCallGroupDocument, options);
      }
export type DeleteCallGroupMutationHookResult = ReturnType<typeof useDeleteCallGroupMutation>;
export type DeleteCallGroupMutationResult = Apollo.MutationResult<DeleteCallGroupMutation>;
export type DeleteCallGroupMutationOptions = Apollo.BaseMutationOptions<DeleteCallGroupMutation, DeleteCallGroupMutationVariables>;